import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";

import { setSelectedFieldsDropdown } from "../store/slice/contactSlice";
import { setProductPreference } from "../store/slice/invoiceSlice";

function FieldsDropdown({
  fieldsData,
  dropdownFor,
  selectedPreference,
  isDisabled,
}) {
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const dispatch = useDispatch();

  const { stripeCustomerNumberPreference } = useSelector(
    (state) => state.contact
  );

  /**
   * @description This function is used for search the values inside the dropdown
   * @param {String} searchValue text entered inside search
   */
  const onSearchFields = (searchValue) => {
    setSearchInput(searchValue);
    let searchArray = [];
    if (
      dropdownFor === "stripeSearchParameter" ||
      dropdownFor === "msbcSearchParameter" ||
      dropdownFor === "stripeCustomerField" ||
      dropdownFor === "msbcCustomerField" ||
      dropdownFor === "stripeProductSearchParameter" ||
      dropdownFor === "msbcProductSearchParameter" ||
      dropdownFor === "msbcField" ||
      dropdownFor === "invoiceTrigger" ||
      dropdownFor === "dealStage"
    ) {
      searchArray = fieldsData.filter((fieldItem) =>
        fieldItem.HRF.toLowerCase().includes(searchValue.toLowerCase())
      );
    } else {
      searchArray = fieldsData.filter((fieldItem) =>
        fieldItem.title.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    setSearchResults(searchArray);
  };

  /**
   * @description This function is responsible for finding the labels for dropdowns based on its selected or default value
   * @param {String} preferenceValue selected or default value associated with labels
   * @returns Text(label) displayed for dropdowns
   */
  const findSyncFieldsTitle = (preferenceValue) => {
    if (
      dropdownFor === "stripeSearchParameter" ||
      dropdownFor === "msbcSearchParameter" ||
      dropdownFor === "stripeCustomerField" ||
      dropdownFor === "msbcCustomerField" ||
      dropdownFor === "stripeProductSearchParameter" ||
      dropdownFor === "msbcProductSearchParameter" ||
      dropdownFor === "invoiceProduct" ||
      dropdownFor === "msbcField" ||
      dropdownFor === "invoiceTrigger" ||
      dropdownFor === "dealStage"
    ) {
      const field = fieldsData.find(
        (fieldItem) => fieldItem.CRF === preferenceValue
      );
      if (field) {
        return field.HRF;
      } else {
        return "property deleted";
      }
    } else {
      const field = fieldsData.find(
        (fieldItem) => fieldItem.value === preferenceValue
      );
      if (field) {
        return field.value && !field.title ? field.value : field.title;
      } else {
        return "property deleted";
      }
    }
  };

  /**
   * @description This function is responsible for showing selected text in the dropdown button
   * @returns returns selected option title if existing else returns a string as shown below
   */
  const toggleText = () => {
    if (
      dropdownFor === "stripeSearchParameter" ||
      dropdownFor === "stripeCustomerField" ||
      dropdownFor === "stripeProductSearchParameter"
    ) {
      if (!selectedPreference) {
        return "Select stripe property";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    } else if (
      dropdownFor === "msbcSearchParameter" ||
      dropdownFor === "msbcCustomerField" ||
      dropdownFor === "msbcProductSearchParameter"
    ) {
      if (!selectedPreference) {
        return "Select msbc property";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    } else if (
      dropdownFor === "paymentTermsCode" ||
      dropdownFor === "currencyCode" ||
      dropdownFor === "customerPostingGroup" ||
      dropdownFor === "vatBusinessPostingGroup" ||
      dropdownFor === "generalBusinessPostingGroup"
    ) {
      if (!selectedPreference) {
        return "Select";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    } else if (dropdownFor === "invoiceProduct") {
      if (!selectedPreference) {
        return "Select msbc product";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    } else if (dropdownFor === "msbcField") {
      if (!selectedPreference) {
        return "Select msbc field";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    } else if (dropdownFor === "invoiceTrigger") {
      if (!selectedPreference) {
        return "Select trigger";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    } else if (dropdownFor === "dealStage") {
      if (!selectedPreference) {
        return "Select deal stage";
      } else {
        return findSyncFieldsTitle(selectedPreference.value);
      }
    }
  };

  return (
    <Dropdown
      style={{ cursor: `${isDisabled && "not-allowed"}` }}
      className="mt-2"
    >
      <Dropdown.Toggle className="setup-fields-dropdown" disabled={isDisabled}>
        {fieldsData && toggleText()}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="pt-0"
        renderOnMount={true}
        popperConfig={{ strategy: "fixed" }}
      >
        <div className="p-3">
          <div className="d-flex flex-row dropdown-search-box">
            <span className="my-auto">
              <CiSearch size={18} className="mx-2" />
            </span>
            <input
              type="search"
              placeholder="search.."
              className="w-100 dropdown-search"
              onChange={(e) => onSearchFields(e.target.value)}
            />
          </div>
        </div>
        <hr className="mt-0 px-3" style={{ border: "1px solid #E0E6EB" }} />

        {dropdownFor === "stripeSearchParameter" ||
        dropdownFor === "msbcSearchParameter" ||
        dropdownFor === "stripeCustomerField" ||
        dropdownFor === "msbcCustomerField" ||
        dropdownFor === "stripeProductSearchParameter" ||
        dropdownFor === "msbcProductSearchParameter" ||
        dropdownFor === "invoiceProduct" ||
        dropdownFor === "msbcField" ||
        dropdownFor === "invoiceTrigger" ||
        dropdownFor === "dealStage" ? (
          <div className="setup-fields-dropdown-items-container">
            {searchInput.length > 0 && searchResults.length === 0 && (
              <div className="d-flex flex-row justify-content-center">
                <b>No results found</b>
              </div>
            )}

            {fieldsData && fieldsData.length > 0 ? (
              (searchInput.length > 0 ? searchResults : fieldsData).map(
                (fieldItem, index) => (
                  <Dropdown.Item
                    key={index}
                    className="px-3 dropdown-item"
                    disabled={
                      dropdownFor === "stripeCustomerField" &&
                      stripeCustomerNumberPreference.value === "msbc" &&
                      fieldItem.CRF === "tax"
                    }
                    onClick={() => {
                      dropdownFor === "stripeProductSearchParameter" ||
                      dropdownFor === "msbcProductSearchParameter" ||
                      dropdownFor === "invoiceProduct" ||
                      dropdownFor === "msbcField" ||
                      dropdownFor === "invoiceTrigger" ||
                      dropdownFor === "dealStage"
                        ? dispatch(
                            setProductPreference({
                              selectingFor: dropdownFor,
                              selectedOption: fieldItem,
                            })
                          )
                        : dispatch(
                            setSelectedFieldsDropdown({
                              selectingFor: dropdownFor,
                              selectedOption: fieldItem,
                            })
                          );
                    }}
                  >
                    {fieldItem.HRF}
                  </Dropdown.Item>
                )
              )
            ) : (
              <div className="d-flex flex-row justify-content-center">
                <p className="rules-description">No fields found</p>
              </div>
            )}
          </div>
        ) : (
          <div className="setup-fields-dropdown-items-container">
            {searchInput.length > 0 && searchResults.length === 0 && (
              <div className="d-flex flex-row justify-content-center">
                <b>No results found</b>
              </div>
            )}
            {(searchInput.length > 0 ? searchResults : fieldsData).map(
              (fieldItem, index) => (
                <Dropdown.Item
                  key={index}
                  className="px-3 dropdown-item"
                  onClick={() => {
                    dispatch(
                      setSelectedFieldsDropdown({
                        selectingFor: dropdownFor,
                        selectedOption: fieldItem,
                      })
                    );
                  }}
                >
                  {fieldItem.value && !fieldItem.title
                    ? fieldItem.value
                    : fieldItem.title}
                </Dropdown.Item>
              )
            )}
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default FieldsDropdown;
